export enum FollowUpFrequency {
    Monthly = 'Monthly',
    Quarterly = 'Quarterly',
    BiAnnual = 'BiAnnual',
    Annual = 'Annual'
}

export const FollowUpFrequencyLabel: Record<FollowUpFrequency, string> = {
    [FollowUpFrequency.Monthly]: 'شهري',
    [FollowUpFrequency.Quarterly]: 'ربعي',
    [FollowUpFrequency.BiAnnual]: 'نصفي',
    [FollowUpFrequency.Annual]: 'سنوي'
};